@if(userDetermined) {
    <!-- Chat Component -->
    <div class="bg-green-500 container mx-auto max-w-screen-sm h-screen flex flex-col">
        <!-- Chat Header -->
        <div class="container relative pr-3 pl-3 py-2 flex justify-center items-center">
            <!-- Left Section -->
            <div class="absolute left-3 top-3">
                <p-image [imageStyle]="{'border-radius': '8px', 'height': '40px', 'width': '40px', 'background': 'white' }" [src]="'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/app_icon%2Ficon.png?alt=media&token=9047486a-0c6c-4995-9f82-5a9886d59293'" alt="Image" width="150" [preview]="false" />
            </div>
            <!-- Center Section -->
            <div class="text-center">
                <div class="text-xl font-semibold text-white">AnyStore</div>
                <div class="text-[10px] text-white">Smart Lists. Store Prices. Daily Delivery</div>
            </div>
            <!-- Right Section -->
             <!-- @if(userProfile()?.roles?.includes('admin') || userProfile()?.roles?.includes('shopper')) {
                <div class="absolute right-5">
                    <p-button
                        icon="pi pi-arrow-right-arrow-left" 
                        label="Shopper"
                        iconPos="top"
                        size="small"
                        [rounded]="true" 
                        [text]="true" 
                        (click)="switchModes()"
                        class="[&_button]:text-white [&_button]:gap-0 [&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
                </div>
             } -->
        </div>
        <!-- Chat Content -->
        <div #chatContent 
            infiniteScroll
            [scrollWindow]="false"
            [infiniteScrollUpDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolledUp)="onScroll()"
            class="bg-green-100 mx-3 mt-3 flex flex-1 rounded-xl overflow-y-scroll flex-col h-full" 
        >
            <div class="flex flex-col flex-1 justify-end py-3" (click)="resetSuggestions()">
                @for(message of messages; track message.message + message.timestamp + $index) {
                    @if(message.reply) {
                        <div class="flex gap-2 p-3 flex-row-reverse">
                            <div class="flex items-end">
                                <p-avatar icon="pi pi-user" size="normal" shape="circle" />
                            </div>
                            <p class="bg-white p-3 rounded-2xl">
                                {{message.message}} 
                            </p>
                        </div>
                    } @else {
                        <div class="flex gap-2 p-3">
                            <div class="flex items-end">
                                <p-avatar image="https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/profile_pics%2Fsira_chatbot_dp.png?alt=media&token=9f926d99-fba5-4c0e-a045-dc75aa3749b3" size="normal" shape="circle" />
                            </div>
                            <div class="bg-green-50 p-3 rounded-2xl">
                                @if(message.type === messageType.message) {
                                    <div [innerHTML]="message.message"></div>
                                } @else if(message.type === messageType.action) {
                                     <div [innerHTML]="message.message"></div>
                                    @if(message.reference === 'resentOtp') {
                                        @if(resendOtpCounter() > 0) {
                                            <div>Resend OTP in {{resendOtpCounter()}}</div>
                                        } @else {
                                            @for(action of message.actions; track action.label) {
                                                <div class="my-2">
                                                    <p-button
                                                        (click)="action.action()"
                                                        [label]="action.label"
                                                        [style]="{background: '#4D7935'}"
                                                        class="[&_button]:border-0 [&_button]:text-white" />
                                                </div>
                                            }
                                        }
                                    } @else if (message.reference === 'add-item') {
                                        <div class="my-2">
                                            <p-button
                                                (click)="openCartInDialog()"
                                                [label]="'View Shopping List'"
                                                [style]="{background: '#4D7935'}"
                                                class=" [&_button]:border-0 [&_button]:text-white" />
                                        </div>
                                    } @else {
                                        @for(action of message.actions; track action.label) {
                                        
                                            <div class="my-2">
                                                <p-button
                                                    (click)="action.action()"
                                                    [label]="action.label"
                                                    [style]="{background: '#4D7935'}"
                                                    class=" [&_button]:border-0 [&_button]:text-white" />
                                            </div>
                                        }
                                    }
                                    
                                } @else if(message.type === messageType.json) {
                                    @if(message.reference === 'cartItem') {
                                        <div class="relative">
                                                @if(message.message){<div style="padding: 5px 20px 8px 5px;" [innerHTML]="message.message"></div>}
                                                <div class="p-5 rounded-2xl bg-orange-100"> 
                                                <div><label class="font-bold">Item Name: </label> {{message.cartItem?.name}}</div>
                                                <div><label class="font-bold">Quantity: </label> {{message.cartItem?.quantity + ' ' +  message.cartItem?.unit}}</div>
                                                <div><label class="font-bold">Store Name: </label> {{message.cartItem?.store}}</div>
                                                <div><label class="font-bold">Store Location: </label> {{message.cartItem?.location}}</div>
                                                </div>
                                                <div class="my-2">
                                                <p-button
                                                    (click)="openCartInDialog()"
                                                    [label]="'View Shopping List'"
                                                    [style]="{background: '#4D7935'}"
                                                    class="w-full [&_button]:w-full [&_button]:border-0 [&_button]:text-white" />
                                            </div>
                                            <p-avatar class="absolute -top-5 -right-6" icon="pi pi-pen-to-square" size="large" shape="circle" (click)="editItem(message.cartItem)" />
                                        </div>
                                    } @else if (message.reference === 'suggestions') {
                                        <div class="relative">
                                            <div [innerHTML]="message.message"></div>
                                            @if(message.suggestions?.relatedItems?.length) {
                                                <div class="my-2 font-semibold">Related Items</div>
                                                <div class="flex justify-start items-center flex-wrap gap-2">
                                                    @for (item of message.suggestions?.relatedItems; track $index) {
                                                        <div [ngClass]="{'opacity-80': item.id}"  class="py-1 px-4 rounded-2xl border-0 bg-orange-100 flex-shrink-0" (click)="!item.id && addSuggestedItemToCart(message.suggestions?.actualMessage || '', item); item.id = 'temp-id';">{{item.name}} @if(item.id){<i class="pi pi-check text-green-500 font-bold"></i>}</div>
                                                    }
                                                </div>
                                                
                                            }
                                            @if(message.suggestions?.basedOnPastOrders?.length) {
                                                <div class="my-2 font-semibold">From Past Orders</div>
                                                <div class="flex justify-start items-center flex-wrap gap-2">
                                                    @for (item of message.suggestions?.basedOnPastOrders; track $index) {
                                                        <div [ngClass]="{'opacity-80': item.id}"  class="py-1 px-4 rounded-2xl border-0 bg-orange-100 flex-shrink-0" (click)="!item.id && addSuggestedItemToCart(message.suggestions?.actualMessage || '', item); item.id = 'temp-id'">{{item.name}} @if(item.id){<i class="pi pi-check text-green-500 font-bold"></i>}</div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    } @else if(message.reference === 'orderDetails') {
                                        <div class="relative">
                                            <div [innerHTML]="message.message"></div>
                                            <div class="p-5 rounded-2xl bg-orange-100 my-2"> 
                                                <div><label class="font-bold">Order Number: </label> {{message.orderDetails?.orderNumber}}</div>
                                                <div><label class="font-bold">Estimated Delivery Time: </label> {{message.orderDetails?.estimatedDeliveryWindow}}</div>
                                                <div><label class="font-bold">Delivery Address: </label> {{message.orderDetails?.deliveryLocation?.fullAddress}}</div>
                                            </div>
                                            <div class="my-2">
                                                <p-button
                                                (click)="showOrderDetails(message.orderDetails)"
                                                [label]="'View Order Details'"
                                                [style]="{background: '#4D7935'}"
                                                class="w-full [&_button]:w-full [&_button]:border-0 [&_button]:text-white" />
                                                 @if (!utilityService.notificationsPermissionStatus?.granted) {
                                                    <p-button
                                                        (click)="getDevicePushToken()"
                                                        [label]="'Turn On Order Updates Notifications'"
                                                        [style]="{background: '#4D7935', 'margin-top': '5px'}"
                                                        class="w-full [&_button]:w-full [&_button]:border-0 [&_button]:text-white" />
                                                 }
                                            </div>
                                                
                                        </div>
                                    } 
                                    
                                } @else if(message.type === messageType.loader) {
                                    <div class="loader-message">
                                        @if(message.message) {
                                        <div [innerHTML]="message.message"></div>
                                        } @else if (previewText) {
                                            <div [innerHTML]="previewText"></div>
                                        }
                                        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration="1s" [style]="{ width: '30px', height: '30px' }" />
                                    </div>
                                } @else if (message.type === messageType.info) {
                                    <div class="relative">
                                        <div>🥳 Great question! Here's why AnyStore is a game changer:</div>
                                        <div class="p-5 rounded-2xl bg-orange-100 my-2"> 
                                            <div class="mb-2"><label class="font-bold">Shop from all your favorite stores at once — </label> Big Chains, Ethnic stores, Mom & Pop Stores… we got you. No store restrictions. One list, one trip, zero stress.</div>
                                            <div class="mb-2"><label class="font-bold">No more endless scrolling. </label>Just tell me what you need — "oat milk, bananas, and organic chicken" — and I'll take care of the rest.</div>
                                            <div class="mb-2"><label class="font-bold">We remember your preferences. </label>We remember your favorite stores, items, brands, and instructions. - Next time, just say "Get my usual stuff" — done</div> 
                                            <div class="mb-2"><label class="font-bold">Real store receipts, no markups. </label>You get the actual store receipt and pay what's on it — no hidden markups — transparent and fair.</div>
                                            <div class="mb-2"><label class="font-bold">Personal shoppers who shop like you would. </label>They check freshness, follow your notes, and chat if something's out.</div> 
                                            <div class="mb-2"><label class="font-bold">Smarter fees, not sneaky ones. </label>You see shopping & delivery fees upfront — based on distance and effort, not surprises.</div>
                                            <div class="mb-2"><label class="font-bold">Need last-minute edits? </label>Add items or make changes anytime before shopping starts.</div> 
                                        </div>
                                        <div>✨ Basically — it's shopping that feels like magic (but powered by real humans who care). Ready to build your list? Just text or talk to me. Simple as that!</div>
                                    </div>
                                }
                                
                            </div>
                        </div>
                    }
                }

                <!-- @if(previewText) {
                    <div class="flex gap-2 p-3">
                        <div class="flex items-end">
                            <p-avatar image="https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/profile_pics%2Fsira_chatbot_dp.png?alt=media&token=9f926d99-fba5-4c0e-a045-dc75aa3749b3" size="normal" shape="circle" />
                        </div>
                        <div class="bg-green-50 p-3 rounded-2xl">
                            <div [innerHTML]="previewText"></div>
                            <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration="1s" [style]="{ width: '30px', height: '30px' }" />
                        </div>
                    </div>
                } -->
            </div>
        </div>
        <!-- Chat Footer -->
        <div class="container bg-green-500 ">

            <!-- Login Flow -->
            @if(showLoginFlow) {
                <div class="m-2">
                    @if(showLoginForm) {
                        @if(!otpSent) {
                            <div class="container flex items-center p-2">
                                <p-iftalabel class="flex-1">
                                    <input [inputMode]="'numeric'" pInputText id="phone_number_label" [formControl]="phoneNumber" autocomplete="off" class="w-full border-none rounded-xl"/>
                                    <label for="phone_number_label">Phone Number</label>
                                </p-iftalabel>
                                <div class="w-16 h-fit flex items-center justify-center">
                                    <p-button
                                        icon="pi pi-send" 
                                        [rounded]="true" 
                                        [text]="true" 
                                        [disabled]="!phoneNumber.valid"
                                        (click)="loginWithPhoneNumber()"
                                        class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-3xl [&_.p-button-icon]:text-white" />
                                </div>
                            </div>
                        } @else {
                            <div class="container flex items-center justify-center p-2">
                                <p-inputotp #inputOtp appNumericInputMode inputmode="numeric" [formControl]="otp" [length]="6" [integerOnly]="true" [autofocus]="true" />
                            </div>
                        }
                        
                    } @else {
                        <div class="flex gap-2 p-2">
                            <div class="flex-1">
                                <p-button (click)="login()" styleClass="w-full rounded-full bg-white border-none bg-green-500 text-sm font-bold uppercase cursor-pointer">Login</p-button>
                            </div>
                            <div class="flex-1">
                                <p-button (click)="explore()" styleClass="w-full rounded-full bg-white border-none bg-green-500 text-sm font-bold uppercase cursor-pointer">Explore App</p-button>
                            </div>
                        </div>
                    }
                    
                </div>
            }
            <div id="recaptcha-container"></div>

            <!-- Message Input -->
            @if(showMessageInputContainer && !voiceRecognitionInProgress) {
                @if(readyToChat && !inPersonalizationFlow && (showTopGroceryCategories || selectedTopGroceryCategory  || (grocerySuggestions && grocerySuggestions.length > 0))) {
                    <div #suggestionscontainer class="w-full pt-4 overflow-x-auto flex justify-start items-center relative" [ngClass]="selectedTopGroceryCategory ? '': 'pl-4'">
                        
                        @if((showTopGroceryCategories || selectedTopGroceryCategory) && grocerySuggestions.length === 0) {
                            @if(selectedTopGroceryCategory) {
                                <div class="sticky left-0 bg-green-500 px-2 h-12  flex items-center">
                                    <i class="pi pi-chevron-left text-white" (click)="selectedTopGroceryCategory = undefined"></i>
                                </div>
                                @for(item of selectedTopGroceryCategory.items; track item) {
                                    <div class="py-1 px-3 mx-1 rounded-2xl border-0 bg-orange-100 flex-shrink-0 cursor-pointer" (click)="onTopGroceryItemSelection({name: item})">{{item}}</div>
                                }
                            } @else {
                                @for(topCategory of topGroceryData?.groceryCategoryList; track topCategory.category) {
                                    <div class="py-1 px-4 mx-1 rounded-2xl border-0 bg-orange-100 flex-shrink-0 cursor-pointer" (click)="onTopGroceryCategorySelection(topCategory)">{{topCategory.category}}</div>
                                }
                            }
                        }
                        @for (suggestion of grocerySuggestions; track $index) {
                            <div class="py-1 px-4 mx-1 rounded-2xl border-0 bg-orange-100 flex-shrink-0" (click)="onTopGroceryItemSelection(suggestion.item)">
                                {{suggestion.item.name}} 
                                @if(suggestion.item.orderedOn){ 
                                    <span style="font-size: 8px;">Ordered on {{suggestion.item.orderedOn | date: 'MM/dd/YYYY'}}</span>
                                }
                                @if(suggestionItemBeingAdded?.id === suggestion.item.id) {
                                    <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration="1s" [style]="{ width: '15px', height: '15px' }" />
                                }
                            
                            </div>
                        }
                        <div class="sticky right-0 bg-green-500 px-2 h-12 flex items-center">
                            <i class="pi pi-times text-white" (click)="resetSuggestions()"></i>
                        </div>
                    </div>
                }
                
                <div class="container flex items-center py-2">
                    <input 
                        #messageInput
                        pInputText 
                        class="flex-1 h-10 rounded-full ml-4 my-2 border-none"
                        type="text" 
                        (focus)="onFocus()"
                        (blur)="onBlur()"
                        [formControl]="message" 
                    />
                    <div class="w-24 h-fit flex items-center justify-center">
                        <p-button
                            icon="pi pi-microphone" 
                            [rounded]="true" 
                            [text]="true" 
                            (click)="startVoiceRecording()"
                            class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-2xl [&_.p-button-icon]:text-white" />
                        <p-button
                            icon="pi pi-send" 
                            [rounded]="true" 
                            [text]="true" 
                            (click)="sendMessage()"
                            class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-2xl [&_.p-button-icon]:text-white" />
                    </div>
                </div>
            }

            @if(voiceRecognitionInProgress) {
                <div class="container flex flex-col items-center justify-between gap-6 p-4 relative">
                    <div class="mic-container">
                        <div class="circle active">
                            <i class="pi pi-microphone"></i>
                        </div>
                    </div>
                    <div class="flex flex-col items-center justify-center gap-2 px-4">
                        @if (!voiceMessage) {
                            <div class="text-white text-center">{{ 'I am listening...you could just say add milk, eggs, peanut butter to the list'}}</div>
                            <!-- <div class="text-white">{{ 'hint: '}}</div> -->
                        }
                        <div class="text-white text-center">{{ voiceMessage}}</div>
                    </div>
                    <div class="flex items-centerjustify-center gap-4">
                        <p-button
                            icon="pi pi-times" 
                            [rounded]="false" 
                            [text]="true" 
                            [label]="'Cancel'"
                            [size]="'small'"
                            (click)="stopVoiceRecording()"
                            class="[&_button]:w-32 [&_button]:bg-transparent [&_button]:border-green-50 [&_button]:text-white [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-xl [&_.p-button-icon]:text-white" />
                        <p-button
                            icon="pi pi-send" 
                            [rounded]="false" 
                            [text]="true" 
                            [label]="'Send'"
                            [size]="'small'"
                            [disabled]="!voiceMessage"
                            (click)="stopAndSendMessage()"
                            class="[&_button]:w-32 [&_button]:bg-transparent [&_button]:border-green-50 [&_button]:text-white [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-xl [&_.p-button-icon]:text-white" />
                    </div>
                   
                </div>
            }
            
        </div>
    </div>
} @else {
    <div class="flex w-full h-screen justify-center items-center">
        <p-progress-spinner strokeWidth="4" [style]="{ width: '80px', height: '80px' }" />
    </div>
}

<!-- 4D7935 FEFEF1 -->